import { Suspense, lazy } from "react";
import Loader from "../customs/loader/main";
import Layout from "../components/dashboard/main";

const Main = lazy(() => import("../components/paymentHistory/main"));

const PaymentHistory = () => {
  return (
    <Layout pageHeading="Payment History">
      <Suspense fallback={<Loader />}>
        <Main />
      </Suspense>
    </Layout>
  );
};

export default PaymentHistory;
